<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}
    </h1>
  </div>

  <div v-if="load_general_data" class="bg-white shadow overflow-hidden sm:rounded-md">
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="agroexporter_process in agroexporter_processes"
        :key="agroexporter_process.id"
      >
        <div
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowProcess(agroexporter_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agroexporter_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible"
                  ><i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>Gestionar
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="flex items-center text-sm text-gray-500">
                  <i
                    class="fa-solid fa-ship flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{
                    agroexporter_process.agro_exporter_process_stat
                      .num_exportations
                  }}
                </p>
                <p
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                >
                  <i
                    class="fa-solid fa-truck-container flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{
                    agroexporter_process.agro_exporter_process_stat
                      .num_containers
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import UniqFinalPackingListRequester from "@/views/agro_exporter/requesters/production/uniq_final_packing_list.js";

export default {
  name: "AEProductionBasicContainerExportShowProcesses",
  components: {},
  props: ["agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      agroexporter_processes: []
    };
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      let response =
        await UniqFinalPackingListRequester.fetchAgroExporterProcesses(
          this.agro_exporter_id
        );
      this.agroexporter_processes = response.data;
      this.load_general_data = true;
    },
    goToShowProcess: function (agroexporter_process) {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_containers_path",
        params: {
          agro_exporter_process_id: agroexporter_process.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchAgroExporterProcesses())
    );
  }
};
</script>
